import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiServiceV2 } from '../../../shared/services/api.serviceV2';
import { ChangePassword } from '../models/change-password';
import { InfoToken } from '../models/info-token';
import { Agency } from '../models/agency';
import { SignupRequest } from '../models/signup-request';
import { environment } from '../../../../../src/environments/environment';

/** SignupService */
@Injectable({ providedIn: 'root' })
export class SignupService extends ApiServiceV2 {
  baseUrl = environment.urlIdentity;
  /** SignupService */
  constructor(http: HttpClient) {
    super('signup', http);
  }

  /** Gets the agencies */
  getAgencies(): Observable<Array<Agency>> {
    return this.http.get<Array<Agency>>(this.url('agencies'));
  }

  /** Post signup request */
  postSignupRequest(request: SignupRequest): Observable<boolean> {
    return this.http.post<boolean>(this.url('request-sign-up'), request);
  }

  /** Post new password */
  postPasswordChange(passwordChange: ChangePassword): Observable<void> {
    return this.http.post<void>(this.url('change-password'), passwordChange);
  }

  /**  Check if the user has accepted the privacy policy */
  checkPrivacyPolicy(eMail: string): Observable<boolean> {
    return this.http.get<boolean>(this.url('must-accept-privacy-policy'), {
      params: { eMail: eMail },
    });
  }

  /** Get info token */
  getInfoToken(token: string): Observable<InfoToken> {
    return this.http.get<InfoToken>(this.url('info-token'), {
      params: { token: token },
    });
  }
}
